<template>
  <div :style="nodeMargin">
    <div
      :class="{
        'flex pr-2 node mb-1 nav-link': true,
        'bg-white active': node.selected,
        'loading': loading
      }"
      @click="$emit('select:component', node._id)"
    >
      <label :class="{
        'cursor-pointer': true,
      }">
        {{ node.name }}
      </label>
      <span
        class="ml-auto cursor-pointer"
        title="add dependency"
        @click.stop="$emit('openAdd', node._id)"
      >
        <i class="fa-solid fa-plus"></i>
      </span>
      <span
        v-if="node.name !== 'app'"
        class="ml-2 cursor-pointer" title="remove this component"
        @click.stop="$emit('remove:dep', { nodeId: node._id, parentId: node.pid })"
      >
        <i class="fa-solid fa-trash-can"></i>
      </span>
    </div>
    <div v-if="hasChildren">
      <TreeNode
        v-for="child in node.children"
        :key="child.id"
        :node="child"
        :spacing="spacing + 10"
        :loading="loading"
        v-bind="$attrs"
      />
    </div>
  </div>
</template>
<script>
export default {
  name: 'TreeNode',
  props: {
    loading: {
      type: Boolean,
      default: false
    },
    node: {
      type: Object,
      required: true
    },
    spacing: {
      type: Number,
      default: 0
    }
  },
  computed: {
    nodeMargin() {
      return {
        'margin-left': `${this.spacing}px`
      }
    },
    hasChildren() {
      const { children } = this.node
      return children && children.length > 0
    }
  }
}
</script>